<template>
    <div :class="getCSSClass('repository-manager-container')">
        <div :class="getCSSClass('repository-manager-head')">
            <h1 :class="getCSSClass('repository-manager-header')" v-html="repository.name"></h1>
            <button v-if="viewMode == 'list' && false"
                    :class="getCSSClass('repository-manager-upload-button')"
                    v-on:click="upload">
                <span v-html="icon('upload')" :class="getCSSClass('repository-manager-upload-button-icon')"></span>
                <span v-html="translate('Feltöltés')"></span>
            </button>
            <dropdown-button :label="translate('Tárhely-műveletek')"
                             :menuitems="currentOperations"
                             v-on:context="handleContextMenuEvent"
                             :caret="'&#9656;'"
                             open-rotation="90deg"
            ></dropdown-button>

        </div>
        <div :class="getCSSClass('repository-manager-filters-container')">
            <div :class="getCSSClass('repository-manager-search-input-container')">
                <input type="text"
                       :class="getCSSClass('repository-manager-search-input')"
                       :placeholder="searchPlaceholder"
                       :disabled="showDetailSearchWindow"
                       v-model="searchText">
                <span :class="getCSSClass('repository-manager-search-input-search-icon')"
                      v-html="icon('search')">
                </span>
                <span :class="getCSSClass('repository-manager-search-input-buttons')">
                    <button :class="getCSSClass('repository-manager-search-input-clear-button')"
                            v-on:click="searchText = ''"
                            v-if="searchText != ''"
                            v-html="icon('close')"></button>
                <button :class="getCSSClass('repository-manager-detail-search-button')"
                        v-on:click="toggleDetailSearch"
                        v-if="detailSearch"
                        v-html="detailSearchLabel"></button>

                </span>
            </div>
            <div :class="getCSSClass('repository-manager-view-buttons-container')">
                <button v-for="availableViewMode in availableViewModesFiltered"
                        v-html="icon(availableViewMode)+viewModes[availableViewMode]"
                        @click="viewMode = availableViewMode"
                        :class="viewSelectorButtonClass(availableViewMode)"
                ></button>
            </div>
        </div>
        <div :class="getCSSClass('repository-manager-detail-search-container')"
             v-show="showDetailSearchWindow"
        >

            <div :class="getCSSClass('repository-manager-detail-search-notification-row')">
                <div :class="getCSSClass('repository-manager-detail-search-notification')"
                     v-if="showDetailSearchNotificationOnly"
                     v-html="translate('Részletes keresés aktív, kattintson a gombra a megjelenítéshez')"
                ></div>
                <button :class="getCSSClass('repository-manager-detail-search-notification-toggle-button')"
                        v-html="icon('caret-up')"
                        style="transition: transform 100ms linear"
                        v-on:click="showDetailSearchNotificationOnly = !showDetailSearchNotificationOnly"
                        :style="{'transform': showDetailSearchNotificationOnly ? 'rotate(180deg)' : 'none'}"></button>
            </div>
            <div :class="getCSSClass('repository-manager-detail-search-filters-container')" v-if="!showDetailSearchNotificationOnly">
                <div v-for="option in detailSearchOptions"
                     :class="getCSSClass('repository-manager-detail-search-filter-container') +' '+option.containerClass">
                    <label v-html="translate(option.label)"></label>
                    <input v-if="option.type == 'text'"
                           type="text"
                           :class="getCSSClass('repository-manager-detail-search-filter-textinput')"
                           v-model="option.value">
                    <select v-if="option.type == 'select' && !option.multiple"
                            :class="getCSSClass('repository-manager-detail-search-filter-select')"
                            v-model="option.value">
                        <option v-for="valuesetOption in option.valueset"
                                :value="valuesetOption.id"
                                v-html="valuesetOption.label"></option>
                    </select>
                    <searchable-multiselect v-if="option.type == 'select' && option.multiple"
                                       :class="getCSSClass('repository-manager-detail-search-filter-select')"
                                       v-model="option.value"
                                       :valueset="option.valueset"
                                       :revert-x-opening="false"
                                       label-property="label"></searchable-multiselect>
                </div>
                <div :class="getCSSClass('repository-manager-detail-search-filter-container')">
                    <label>&nbsp;</label>
                    <button :class="getCSSClass('repository-manager-detail-search-start-button')"
                            v-on:click="applyDetailSearch"
                            v-html="icon('search')+translate('Keresés')"
                    >
                    </button>
                </div>
            </div>

        </div>

        <div :class="getCSSClass('repository-manager-breadcrumbs-buttons-container')"
             >
            <div :class="getCSSClass('repository-manager-breadcrumbs')"

            >
                <template v-for="node, nodeIndex in currentPath" v-if="viewMode != 'list'">
                <span :class="getCSSClass('repository-manager-breadcrumb')"
                      v-on:click="selectNode(nodeIndex)"
                      >
                    <img v-if="nodeIndex == 0" :src="repository.svg_icon" :class="getCSSClass('repository-manager-breadcrumb-icon')">
                    <span v-else v-html="icon('folder')"></span>
                    <span v-html="node.name" class="ml-2"></span>
                </span>
                    <span v-if="nodeIndex < currentPath.length - 1"
                          v-html="icon('breadcrumbSeparator')"
                          :class="getCSSClass('repository-manager-breadcrumb-separator')">
                    </span>

                </template>
            </div>
            <div :class="getCSSClass('repository-manager-buttons-container')" v-if="buttonsComponent != ''">
                <component :is="buttonsComponent"
                           v-bind:files="files"
                           v-bind:folders="folders"
                           v-bind:selectedFiles="selectedFiles"
                           v-on:reload="fetchElements"></component>
            </div>
        </div>
        <div v-show="loading"  :class="getCSSClass('repository-manager-loader')" v-html="loadingIndicator"></div>
        <div v-show="!loading" :class="getCSSClass('repository-manager-content')">
            <table :class="getCSSClass('repository-manager-listview-container')" v-if="viewMode == 'list'">
                <thead>
                <tr :class="getCSSClass('repository-manager-listview-container-header-row')">
                    <th :class="getCSSClass('repository-manager-listview-select-tablehead')"><input type="checkbox"
                               :class="getCSSClass('repository-manager-listview-container-select-all')"
                               v-model="selectAll"
                    ></th>
                    <th></th>
                    <template v-for="column in currentViewColumns">
                        <th v-if="column.sorting == null" :class="getCSSClass('repository-manager-listview-container-header') + ' ' +getCSSClass('repository-manager-listview-container-header-'+column.field)"
                             v-html="column.label"></th>
                        <th v-if="column.sorting != null" :class="getCSSClass('repository-manager-listview-container-header') + ' ' +getCSSClass('repository-manager-listview-container-header-'+column.field)"
                            v-on:click="toggleSorting(column.sorting)"
                            style="cursor:pointer"
                             >
                            <span v-html="column.label"></span>
                            <span v-html="sortingArrow(column.sorting)"
                                  :class="sortingArrowClass(column.sorting)"></span>
                        </th>
                    </template>
                    <th v-html="icon('comments')"></th>

                </tr>
                </thead>
                <tbody>
                    <tr v-if="sortedElements.files.length == 0">
                        <td :colspan="currentViewColumns.length + 1"
                            :class="getCSSClass('repository-manager-listview-container-no-items-cell')"
                            v-html="translate('Nincs megjeleníthető elem')"></td>
                    </tr>
                    <template v-else>
                        <tr v-for="file, fileIndex in sortedElements.files" :key="'file-'+file.id"
                            v-on:contextmenu="handleContextMenuClick($event, file, 'file')"
                            :title="file.description"
                            :class="getCSSClass('repository-manager-listview-item')"
                        >
                            <td><input type="checkbox" v-model="selectedFiles" :value="file.id"></td>
                            <td v-html="file.icon"
                                :class="getIconCellClass(file, getCSSClass('repository-manager-listview-icon-cell'))"
                                v-on:click="handleElementClick(file, fileIndex)"
                            ></td>
                            <template v-for="column in currentViewColumns">
                                <td v-if="column.field == 'tags'"
                                    :class="getCSSClass('repository-manager-listview-container-item-column') + ' ' +getCSSClass('repository-manager-listview-container-item-column-'+column.field)">
                                    <div :class="getCSSClass('repository-manager-tags-subcontainer')">
                                    <span v-for="tag in file.tags"
                                          :class="getCSSClass('repository-manager-tag-span')"
                                          v-html="tag.name"></span>
                                    </div>
                                </td>
                                <template v-else>
                                    <td v-if="column.field == nameField && (showDetailSearchWindow || searchText != '')"
                                        :class="getCSSClass('repository-manager-listview-container-item-column') + ' ' +getCSSClass('repository-manager-listview-container-item-column-'+column.field)"

                                    >
                                        <span v-html="file[column.field]"></span>
                                        <br>
                                        <span :class="getCSSClass('repository-manager-listview-container-item-path')"
                                              v-on:click="jumpToPath(keyedFolders[file.folder_id])"
                                              v-html="getFullPathString(file)">
                                        ></span>

                                    </td>

                                    <td v-else
                                        :class="getCSSClass('repository-manager-listview-container-item-column') + ' ' +getCSSClass('repository-manager-listview-container-item-column-'+column.field)"
                                        v-html="file[column.field]">

                                    </td>

                                </template>
                            </template>
                            <td :class="getCSSClass('repository-manager-listview-container-item-column') + ' ' +getCSSClass('repository-manager-listview-container-item-column-comments')">
                                <tooltip v-if="file.comments_count > 0"
                                         :operations-url="operationsUrl"
                                         :subject="file.filename_on_disk"
                                ><span v-html="icon('comments')"></span>

                                </tooltip>
                            </td>
                        </tr>
                        <tr v-show="sortedElements.files[sortedElements.files.length -1].queryCursor && parseInt(pagination) > 0">
                            <td :colspan="currentViewColumns.length + 4" style="vertical-align: center; justify-content: center">
                                <div :class="getCSSClass('repository-manager-listview-load-more-button-container')">
                                    <button :class="getCSSClass('repository-manager-listview-load-more-button')"
                                            v-on:click="fetchMoreElements"
                                    ><span style="margin-right: 1rem" v-html="loadingIndicator" v-show="loadingMore"></span>További {{ pagination }} elem betöltése</button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div :class="getCSSClass('repository-manager-gridview-container')" v-if="viewMode == 'grid'">
                <template v-if="currentPath.length > 1">
                    <div :class="getCSSClass('repository-manager-gridview-item') + ' ' + getCSSClass('repository-manager-gridview-item-move-up')"
                         v-on:click="currentPath.pop()"
                         v-html="moveUpLabel"
                    ></div>
                </template>
                <div v-if="sortedElements.files.length == 0 && sortedElements.folders.length == 0"
                    :class="getCSSClass('repository-manager-gridview-container-no-items-cell')"
                    v-html="translate('Nincs megjeleníthető elem')">
                </div>
                <template v-else>
                    <div v-for="folder in sortedElements.folders"
                         :key="'f-'+folder.id"
                         :class="getCSSClass('repository-manager-gridview-item') + ' ' + getCSSClass('repository-manager-gridview-item-folder')"
                         v-on:click="setCurrentPathToFolder(folder)"
                         v-on:contextmenu="handleContextMenuClick($event, folder, 'folder')"

                    >
                        <div v-html="folder.icon"
                             :class="getCSSClass('repository-manager-gridview-folder-icon')"></div>
                        {{ folder.name }}
                    </div>
                    <div v-for="file, fileIndex in sortedElements.files" :key="'file-'+file.id"
                         :title="file.description"
                         v-on:contextmenu="handleContextMenuClick($event, file, 'file')"

                         :class="getCSSClass('repository-manager-gridview-item') + ' ' + getCSSClass('repository-manager-gridview-item-file')"
                    >
                        <div v-html="file.icon"
                             v-on:click="handleElementClick(file, fileIndex)"
                             :class="getCSSClass('repository-manager-gridview-file-icon')"></div>
                        <template v-for="column in currentViewColumns">
                            <div v-if="column.field == 'tags'"
                                :class="getCSSClass('repository-manager-gridview-file-row') + ' ' +getCSSClass('repository-manager-folderview-container-item-column-'+column.field)">
                                <div :class="getCSSClass('repository-manager-tags-subcontainer')">

                                    <span v-for="tag in file.tags"
                                          :class="getCSSClass('repository-manager-tag-span')"
                                          v-html="tag.name"></span>
                                </div>
                            </div>
                            <div v-else
                                 :class="getCSSClass('repository-manager-gridview-file-row')+' '+getCSSClass('repository-manager-gridview-file-row-'+column.field)"

                            ><span v-html="file[column.field]"></span>
                                <template v-if="column.field == nameField && (showDetailSearchWindow || searchText != '')">
                                    <br>
                                    <span :class="getCSSClass('repository-manager-listview-container-item-path')"
                                          v-on:click="jumpToPath(keyedFolders[file.folder_id])"
                                          v-html="getFullPathString(file)">
                                        ></span>
                                </template>
                            </div>

                        </template>
                        <input type="checkbox" v-model="selectedFiles" :value="file.id">
                        <div :class="getCSSClass('repository-manager-gridview-container-item-column') + ' ' +getCSSClass('repository-manager-gridview-container-item-column-comments')">
                            <tooltip v-if="file.comments_count > 0"
                                     :operations-url="operationsUrl"
                                     :subject="file.filename_on_disk"
                            ><span v-html="icon('comments')"></span>

                            </tooltip>
                        </div>


                    </div>
                </template>
            </div>
            <table :class="getCSSClass('repository-manager-folderview-container')" v-if="viewMode == 'folder'">
                <thead>
                <tr :class="getCSSClass('repository-manager-folderview-container-header-row')">
                    <th  :class="getCSSClass('repository-manager-folderview-select-tablehead')"><input type="checkbox"
                               :class="getCSSClass('repository-manager-folderview-container-select-all')"
                               v-model="selectAll"
                    ></th>
                    <th></th>
                    <template v-for="column in currentViewColumns">
                        <th v-if="column.sorting == null" :class="getCSSClass('repository-manager-folderview-container-header') + ' ' +getCSSClass('repository-manager-folderview-container-header-'+column.field)"
                            v-html="column.label"></th>
                        <th v-if="column.sorting != null" :class="getCSSClass('repository-manager-folderview-container-header') + ' ' +getCSSClass('repository-manager-folderview-container-header-'+column.field)"
                            v-on:click="toggleSorting(column.sorting)"
                            style="cursor:pointer"
                        >
                            <span v-html="column.label"></span>
                            <span v-html="sortingArrow(column.sorting)"
                                  :class="sortingArrowClass(column.sorting)"></span>
                        </th>
                    </template>
                    <th v-html="icon('comments')"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="currentPath.length > 1"
                    v-on:click="moveUpOneFolder"
                    :class="getCSSClass('repository-manager-folderview-item')">
                    <td :colspan="currentViewColumns.length + 1"

                        v-html="moveUpLabel"
                        :class="getCSSClass('repository-manager-folderview-move-up-cell')"></td>
                </tr>
                <tr v-if="sortedElements.files.length == 0 && sortedElements.folders.length == 0">
                    <td :colspan="currentViewColumns.length + 2"
                        :class="getCSSClass('repository-manager-folderview-container-no-items-cell')"
                        v-html="translate('Nincs megjeleníthető elem')"></td>
                </tr>
                <template v-else>

                    <tr v-for="folder in sortedElements.folders"
                        :key="'folder-'+folder.id"
                        v-on:contextmenu="handleContextMenuClick($event, folder, 'folder')"

                        :class="getCSSClass('repository-manager-folderview-item') + ' ' + getCSSClass('repository-manager-folderview-item-folder')"
                        v-on:click="setCurrentPathToFolder(folder)"
                    >
                        <td></td>
                        <td v-html="folder.icon" :class="getCSSClass('repository-manager-folderview-icon-cell')"></td>
                        <td v-for="column in currentViewColumns" :class="getCSSClass('repository-manager-folderview-container-item-column') + ' ' +getCSSClass('repository-manager-listview-container-item-column-'+column.field)"
                            v-html="folder[column.field]"
                        ></td>
                        <td></td>
                    </tr>
                    <tr v-for="file, fileIndex in sortedElements.files" :key="'file-'+file.id"
                        :class="folderViewFileRowClass(file.id)"
                        :title="file.description"
                        v-on:contextmenu="handleContextMenuClick($event, file, 'file')"

                    >
                        <td :class="getCSSClass('repository-manager-folderview-select-cell')"><input type="checkbox" v-model="selectedFiles" :value="file.id"></td>
                        <td v-html="file.icon"
                            :class="getIconCellClass(file, getCSSClass('repository-manager-folderview-icon-cell'))"
                            v-on:click="handleElementClick(file, fileIndex)"
                        ></td>

                        <template v-for="column in currentViewColumns">
                            <td v-if="column.field == 'tags'"
                                :class="getCSSClass('repository-manager-folderview-container-item-column') + ' ' +getCSSClass('repository-manager-folderview-container-item-column-'+column.field)">
                                <div :class="getCSSClass('repository-manager-tags-subcontainer')">
                                    <span v-for="tag in file.tags"
                                          :class="getCSSClass('repository-manager-tag-span')"
                                          v-html="tag.name"></span>
                                </div>
                            </td>
                            <template v-else>
                                <td v-if="column.field == nameField && (showDetailSearchWindow || searchText != '')"
                                    :class="getCSSClass('repository-manager-folderview-container-item-column') + ' ' +getCSSClass('repository-manager-folderview-container-item-column-'+column.field)"
                                ><span v-html="file[column.field]"></span>
                                    <br>
                                    <span :class="getCSSClass('repository-manager-listview-container-item-path')"
                                          v-on:click="jumpToPath(keyedFolders[file.folder_id])"
                                          v-html="getFullPathString(file)">
                                        ></span>
                                </td>
                                <td v-else
                                    :class="getCSSClass('repository-manager-folderview-container-item-column') + ' ' +getCSSClass('repository-manager-folderview-container-item-column-'+column.field)"
                                    v-html="file[column.field]">
                                </td>

                            </template>
                        </template>
                        <td :class="getCSSClass('repository-manager-folderview-container-item-column') + ' ' +getCSSClass('repository-manager-folderview-container-item-column-comments')">
                            <tooltip v-if="file.comments_count > 0"
                                     :operations-url="operationsUrl"
                                     :subject="file.filename_on_disk"
                            ><span v-html="icon('comments')"></span>

                            </tooltip>
                        </td>

                    </tr>
                </template>
                </tbody>
            </table>

        </div>
        <popup :visible="showUploadPopup"
               v-on:close="hideUploadPopup"
        >
            <div :class="getCSSClass('repository-manager-function-popup-header')+' '+getCSSClass('repository-manager-function-popup-blue-header')" v-if="uploadComponent == 'RepositoryUploadComponent'">
                <h2 :class="getCSSClass('repository-manager-function-popup-header-mainheader')">
                    <span v-html="icon('upload')" style="margin-right: .5rem"></span>
                    <span v-html="translate('Feltöltés')"></span>
                    <button :class="getCSSClass('edit-form-form-close-button')"
                            v-on:click="hideUploadPopup"
                            type="button"
                            v-html="icon('close')"
                            style="margin-left: auto"
                    ></button>

                </h2>
            </div>
            <component
                    v-if="showUploadPopup"
                    :is="uploadComponent"
                    :operations-url="operationsUrl"
                    :repository="repository"
                    :repository-slug="repositorySlug"
                    :current-path="currentPath"
                    v-bind="JSON.parse(JSON.stringify(uploadComponentProps))"
                    v-on:uploadqueue="uploadQueue = $event"
                    v-on:uploaderror="handleUploadError"
                    v-on:close="hideUploadPopup"
                    :key="uploadComponentKey"
            ></component>
            <div v-if="false"
                    style="width: 100%; display: flex; align-items: center; justify-content: center; padding: .75rem">
                <button style="width: auto; margin-top: 1rem"
                        v-on:click="hideUploadPopup"
                        :disabled="uploadQueue.length > 0"
                        v-html="translate('Bezár')"
                ></button>
            </div>
        </popup>
        <component v-if="contextMenuComponent != ''"
                   :is="contextMenuComponent"
                   :operations-url="operationsUrl"
                   :subject="currentItem"
                   :selected="selectedFiles"
                   :show="showContextMenu"
                   :cursor-position="currentCursorPosition"
                   v-on:hide="showContextMenu = false"
                   v-on:context="handleContextMenuEvent"
                   :menuitems="currentContextMenuItems"
                   :key="contextMenuComponentKey"
        ></component>
        <notification :message="notificationMessage"
                      :display="notificationDisplayFlag"
                      :timeout="notificationTimeout"
                      :button-class="getCSSClass('model-manager-notification-button')"
                      :close-button-label="'OK'"
        ></notification>
        <popup :visible="showFunctionPopup"
               v-on:close="closeFunctionPopup">
            <div v-if="functionPopupLoading" style="width: 100%; padding: 2rem; display: flex; align-items: center; justify-content: center">
                <span v-html="loadingIndicator"></span>
            </div>
            <template v-if="currentItem && !functionPopupLoading">
                <div :class="getCSSClass('repository-manager-function-popup-header') + ' ' + getCSSClass('repository-manager-function-popup-'+activeFunctionClass+'-header')">
                    <h2 :class="getCSSClass('repository-manager-function-popup-header-mainheader')">
                        <span v-html="functionPopupIcon" style="margin-right: .5rem"></span>
                        <span v-html="functionPopupHeader"></span>
                    </h2>
                    <h3 :class="getCSSClass('repository-manager-function-popup-header-subheader')"
                            v-html="functionPopupSubheader"></h3>
                    <button :class="getCSSClass('repository-manager-popup-top-close-button')"
                            v-on:click="closeFunctionPopup"
                            v-html="icon('close')"
                    ></button>

                </div>
                <template v-if="functionPopups.showVersionsPopup">
                    <div v-if="currentItemVersions.length == 1" :class="getCSSClass('repository-manager-file-versions-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Nincsenek régebbi verziók')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"></div>
                        </div>

                    </div>
                    <div v-else :class="getCSSClass('repository-manager-file-versions-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-file-versions-table-container')">
                            <table :class="getCSSClass('repository-manager-file-versions-table')">
                                <thead>
                                <tr>
                                    <th v-html="translate('Verzió')"></th>
                                    <th v-html="translate('Dátum')"></th>
                                    <th v-html="translate('Fájlméret')"></th>
                                    <th v-html="translate('Megjegyzés')"></th>
                                    <th v-html="translate('Művelet')"></th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="version, index in currentItemVersions">
                                        <td v-html="version.version_number"></td>
                                        <td v-html="version.created_at_label"></td>
                                        <td v-html="version.size_label"></td>
                                        <td v-html="''"></td>
                                        <td>
                                            <button v-on:click="downloadVersion(version.version_number)"
                                                    :class="getCSSClass('repository-manager-file-versions-download-button')"
                                                    v-html="translate('Letöltés')"
                                            ></button>
                                            <button v-on:click="restoreVersion(version.version_number)"
                                                    v-if="index > 0 && currentAccessLevel > 1"
                                                    :class="getCSSClass('repository-manager-file-versions-restore-button')"
                                                    v-html="translate('Visszaállítás')"
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                        <button :class="getCSSClass('repository-manager-popup-close-button')"
                                v-on:click="closeFunctionPopup"
                                v-html="translate('Bezár')"
                        ></button>
                    </div>
                </template>

                <template v-if="functionPopups.showSharePopup">
                    <div :class="getCSSClass('repository-manager-function-popup-share-url-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Megosztási link')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <input type="text" readonly v-bind:value="shareUrl">
                                <button :class="getCSSClass('repository-manager-function-copy-button')"
                                        v-if="allowClipboard"
                                        style="transition: color 200ms ease-in-out"
                                        v-on:click="copyToClipboard(shareUrl)"
                                        :style="{color: copiedToClipboard ? 'green' : 'initial'}"
                                >
                                    <span v-html="icon('clipboard-copy')"></span>
                                </button>

                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('A megosztás megtekintése')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                            <select v-model="shareAuthRequired">
                                <option value="1" v-html="translate('Bejelentkezést követel')"></option>
                                <option value="0" v-html="translate('Nem szükséges bejelentkezni')"></option>
                            </select>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="saveShareUrl"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupLoading"
                                  :style="{'opacity': functionPopupLoading ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="cancelShareUrl"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>

                    </div>
                </template>
                <template v-if="functionPopups.showDescriptionPopup">
                    <div :class="getCSSClass('repository-manager-description-editor-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                    <div :class="getCSSClass('repository-manager-function-popup-row')">
                        <div :class="getCSSClass('repository-manager-function-popup-column')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Leírás')"></label></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-column')">

                            <textarea v-model="currentItem.description"
                                      :class="getCSSClass('repository-manager-description-editor-textarea')"
                            ></textarea>
                        </div>
                    </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-if="currentAccessLevel > 1"
                                    v-on:click="saveDescription"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="cancelDescriptionEditing"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showCommentsPopup">
                    <div :class="getCSSClass('repository-manager-comments-editor-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <table :class="getCSSClass('repository-manager-comments-table')">
                                <thead>
                                <tr>
                                    <th v-html="translate('Dátum')"></th>
                                    <th v-html="translate('Felhasználó')"></th>
                                    <th v-html="translate('Megjegyzés')"></th>
                                </tr>
                                </thead>
                                <tbody v-show="!functionPopupProcessing">
                                <tr v-for="comment, index in currentItem.comments">
                                    <td v-html="comment.date_label"></td>
                                    <td v-html="comment.user_label"></td>
                                    <td v-html="comment.content"></td>
                                </tr>
                                </tbody>

                            </table>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <label v-html="translate('Új megjegyzés hozzáadása')"></label>
                            </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <tiny-mce-wrapper v-model="newComment"
                                                  :config="tinymceConfig"
                                                  :min-height="150"
                                                  :class="getCSSClass('repository-manager-comment-editor')"
                                                  style="min-height: 150px"></tiny-mce-wrapper>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                            </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <button v-on:click="addComment"
                                        :disabled="newComment.length < 1 || functionPopupProcessing"
                                        :class="getCSSClass('repository-manager-comments-editor-add-button')"
                                        >
                                    <span v-html="icon('comment')" class="mr-2"></span>
                                    <span v-html="translate('Hozzáadás')"></span>
                                </button>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeCommentsEditing"
                                    v-html="translate('Bezár')"
                            ></button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showLogsPopup">
                    <div :class="getCSSClass('repository-manager-logs-editor-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <table :class="getCSSClass('repository-manager-logs-table')">
                                <thead>
                                <tr>
                                    <th v-html="translate('Ssz.')"></th>
                                    <th v-html="translate('Felhasználó')"></th>
                                    <th v-html="translate('Dátum')"></th>
                                    <th v-html="translate('Esemény')"></th>
                                    <th v-html="translate('Részletek')"></th>
                                </tr>
                                </thead>
                                <tbody v-show="!functionPopupProcessing">
                                <tr v-for="action, index in currentItem.logs">
                                    <td v-html="(index + 1).toString()"></td>
                                    <td v-html="action.user_label"></td>
                                    <td v-html="action.created_at_label"></td>
                                    <td v-html="action.name"></td>
                                    <td v-html="action.description"></td>
                                </tr>
                                </tbody>

                            </table>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                                    v-html="translate('Bezár')"
                            ></button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showAuthorizationsPopup">
                    <div :class="getCSSClass('repository-manager-authorizations-editor-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Jogosultságkezelés módja')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <label :class="getCSSClass('repository-manager-authorization-mode-radio-label')"><input type="radio" v-model="useCustomAuthorization" value="0">{{ translate('Rendszerbeállítások szerint') }}</label>
                                <label :class="getCSSClass('repository-manager-authorization-mode-radio-label')"><input type="radio" v-model="useCustomAuthorization" value="1">{{ translate('Egyéni hozzáférések') }}</label>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')" v-if="useCustomAuthorization == 1">
                            <table :class="getCSSClass('repository-manager-authorizations-table')">
                                <thead>
                                <tr>
                                    <th v-html="translate('Felhasználó')"></th>
                                    <th v-html="translate('Jogosultság')"></th>
                                    <th v-html="translate('Műveletek')"></th>
                                </tr>
                                </thead>
                                <tbody v-show="!functionPopupProcessing">
                                <tr v-for="authorization, index in currentItemAuthorizations">
                                    <td v-html="usersKeyed[authorization.user_id].name"></td>
                                    <td>
                                        <select v-model="authorization.accesslevel"
                                                :class="getCSSClass('repository-manager-authorization-accesslevel-select')">
                                            <option v-for="accessLevel, accessLevelId in accessLevelsWithoutNoAccess"
                                                    v-html="accessLevel"
                                                    :value="accessLevelId"
                                            ></option>
                                        </select>
                                    </td>
                                    <td>
                                        <button v-on:click="removeAuthorizedUser(index)"
                                                :class="getCSSClass('repository-manager-authorization-user-remove-button')"
                                                v-html="icon('delete')"></button>
                                    </td>
                                </tr>
                                </tbody>

                            </table>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')"  v-if="useCustomAuthorization == 1">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Felhasználó hozzáadása')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <select :class="getCSSClass('repository-manager-authorization-user-select')"
                                        v-model="newAuthorizationUser"
                                >
                                    <option v-for="u in currentItemAuthorizationRemainingUsers"
                                            v-html="u.name"
                                            :value="u.id"
                                    ></option>
                                </select>
                                <button v-on:click="addUserToAuthorizationList"
                                        :disabled="!newAuthorizationUser"
                                        :class="getCSSClass('repository-manager-authorization-user-add-button')"
                                        v-html="icon('plus')"
                                ></button>
                            </div>

                        </div>

                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="saveAuthorizations"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="cancelAuthorizations"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showTagsPopup">
                    <div :class="getCSSClass('repository-manager-tags-editor-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')" style="display: flex; flex-direction: column; padding-bottom: 1rem; justify-content: space-between">
                                <label v-html="translate('Hozzáadott címkék')"></label>

                            </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <multi-picker v-model="currentItemTags"
                                            operations-url=""
                                            :urls="urls.tags"></multi-picker>
                            </div>
                        </div>

                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="saveTags"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="cancelTagEditing"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showSwapPopup">
                    <div :class="getCSSClass('repository-manager-swap-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Új dokumentum feltöltése')+'*'"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><file-input v-model="replacementFile" :label="translate('Tallózás')" :button-class="getCSSClass('repository-manager-file-input-button')"></file-input></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleSwap"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showRenamePopup">
                    <div :class="getCSSClass('repository-manager-rename-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Új név') + '*'"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><input type="text" v-model="newFilename" :class="getCSSClass('repository-manager-function-rename-input')"></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleRename"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showCreateFolderPopup">
                    <div :class="getCSSClass('repository-manager-createfolder-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Új mappa neve')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><input type="text" v-model="newFilename" :class="getCSSClass('repository-manager-function-createfolder-input')"></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleCreateFolder"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Létrehozás')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showMediaPlayerPopup">
                    <div :class="getCSSClass('repository-manager-mediaplayer-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott állomány')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="previewSubjectFile.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <media-viewer-component :file="previewSubjectFile" :url="previewSubjectUrl"></media-viewer-component>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="download"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Letöltés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Bezár')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showCopyPopup">
                    <div :class="getCSSClass('repository-manager-copy-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Másolás ebbe a mappába')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <repository-folder-picker :operations-url="operationsUrl"
                                                          :repository="repository"
                                                          :key="folderPickerKey"
                                                          v-model="targetFolder"
                                                          style="min-height: 15rem; max-height: 15rem; overflow-y: auto"
                                ></repository-folder-picker>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Másolat neve')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><input type="text" v-model="newFilename" :class="getCSSClass('repository-manager-function-rename-input')"></div>
                        </div>

                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleCopy"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Másolás')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showMovePopup">
                    <div :class="getCSSClass('repository-manager-move-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott dokumentum')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Aktuális mappa')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentPath[currentPath.length - 1].name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Átmozgatás ebbe a mappába')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <repository-folder-picker :operations-url="operationsUrl"
                                                          :repository="repository"
                                                          :key="folderPickerKey"
                                                          v-model="targetFolder"
                                                          style="min-height: 15rem; max-height: 15rem; overflow-y: auto"
                                                          :move-up-label="moveUpLabel"
                                ></repository-folder-picker>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleMove"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Átmozgatás')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showMoveFolderPopup">
                    <div :class="getCSSClass('repository-manager-move-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Kiválasztott mappa')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Aktuális mappa')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><div :class="getCSSClass('repository-manager-file-label')" v-html="currentPath[currentPath.length - 1].name"></div></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Átmozgatás ebbe a mappába')"></label> </div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')">
                                <repository-folder-picker :operations-url="operationsUrl"
                                                          :repository="repository"
                                                          :key="folderPickerKey"
                                                          v-model="targetFolder"
                                                          style="min-height: 15rem; max-height: 15rem; overflow-y: auto"
                                                          :move-up-label="moveUpLabel"
                                                          :hidden-folders="[currentItem.id]"
                                ></repository-folder-picker>
                            </div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-popup-save-button')"
                                    v-on:click="handleFolderMove"
                            ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Átmozgatás')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showEditorPopup">
                    <div :class="getCSSClass('repository-manager-editor-container')">
                        <component v-if="editComponent != null && functionPopups.showEditorPopup"
                                   :is="editComponent"
                                   :subject="currentItem"
                                   v-on:saved="handleEdit"
                                   v-on:close="closeFunctionPopup('showEditorPopup')"
                                   :current-path="currentPath"
                                   v-bind="editComponentProps"></component>
                    </div>

                </template>
                <template v-if="functionPopups.showDetailsPopup">
                    <div :class="getCSSClass('repository-manager-details-container')">
                        <component v-if="detailsComponent != null && functionPopups.showDetailsPopup"
                                   :is="detailsComponent"
                                   :filename="currentFilename"
                                   :operations-url="this.operationsUrl"
                                   v-on:canceled="closeFunctionPopup('showEditorPopup')"
                                   v-bind="detailsComponentProps"></component>
                    </div>

                </template>
                <template v-if="functionPopups.showFilingPopup">
                    <div :class="getCSSClass('repository-manager-filing-container')">
                        <filing-data-component
                                   :subject="currentItem"
                                   v-model="currentFilingdata"
                                   :urls="urls.filing"
                                   ></filing-data-component>
                    </div>
                    <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                        <button :class="getCSSClass('repository-manager-popup-save-button')"
                                v-on:click="handleFiling"
                        ><span v-html="icon('save')" class="mr-2"></span><span v-html="translate('Mentés')"></span>
                        </button>
                        <span v-html="loadingIndicator"
                              v-show="functionPopupProcessing"
                              :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                        <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                v-on:click="closeFunctionPopup"
                        ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                        </button>
                        <button :class="getCSSClass('repository-manager-clear-filing-button')"
                                v-on:click="clearFiling"
                                style="margin-left: auto"
                        ><span v-html="icon('delete')" class="mr-2"></span><span v-html="translate('Iktatási adatok törlése')"></span>
                        </button>
                    </div>

                </template>
                <template v-if="functionPopups.showDeletePopup">
                    <div :class="getCSSClass('repository-manager-delete-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Dokumentum megnevezése')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></label></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Ellenőrzőkód')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="deleteCode"></label></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Ellenőrzőkód megadása')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><input type="text" v-model="deleteCodeConfirmation" :class="getCSSClass('repository-manager-function-delete-input')"></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-delete-confirmation-button')"
                                    v-on:click="handleDeletion"
                                    :disabled="deleteCode != deleteCodeConfirmation"
                            ><span v-html="icon('delete')" class="mr-2"></span><span v-html="translate('Törlés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>
                <template v-if="functionPopups.showDeleteFolderPopup">
                    <div :class="getCSSClass('repository-manager-delete-container')">
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Mappa megnevezése')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label :class="getCSSClass('repository-manager-file-label')" v-html="currentItem.name"></label></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Ellenőrzőkód')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="deleteCode"></label></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-function-popup-row')">
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><label v-html="translate('Ellenőrzőkód megadása')"></label></div>
                            <div :class="getCSSClass('repository-manager-function-popup-column')"><input type="text" v-model="deleteCodeConfirmation" :class="getCSSClass('repository-manager-function-delete-input')"></div>
                        </div>
                        <div :class="getCSSClass('repository-manager-popup-buttons-container')">
                            <button :class="getCSSClass('repository-manager-delete-confirmation-button')"
                                    v-on:click="handleFolderDeletion"
                                    :disabled="deleteCode != deleteCodeConfirmation"
                            ><span v-html="icon('delete')" class="mr-2"></span><span v-html="translate('Törlés')"></span>
                            </button>
                            <span v-html="loadingIndicator"
                                  v-show="functionPopupProcessing"
                                  :style="{'opacity': functionPopupProcessing ? 1 : 0}"></span>
                            <button :class="getCSSClass('repository-manager-popup-cancel-button')"
                                    v-on:click="closeFunctionPopup"
                            ><span v-html="icon('close')" class="mr-2"></span><span v-html="translate('Mégse')"></span>
                            </button>
                        </div>
                    </div>

                </template>

                <div v-if="this.operationError != ''"
                     :class="getCSSClass('repository-manager-popup-error-container')"
                     v-html="this.operationError"
                ></div>
            </template>
        </popup>
        <popup :visible="showSlideshowPopup" :container-style="'width: auto; min-width:95%; padding: 0px; height: 95vh'">
            <slideshow v-if="showSlideshowPopup"
                       :files="files"
                       v-on:close="showSlideshowPopup = false"
                       :starting-index="slideshowIndex"></slideshow>
        </popup>
        <popup :visible="showPreviewPopup"
               :container-style="'width: auto; min-width:100%; width: 100%; padding: 0px; height: 100vh; background-color: rgba(0,0,0,.6)'">
            <document-previewer v-if="showPreviewPopup"
                                :file="previewSubjectFile"
                       :type="previewSubjectType"
                       :url="previewSubjectUrl"
                       :viewers="previewedTypes"
                       v-on:close="showPreviewPopup = false"
            ></document-previewer>
        </popup>

    </div>
</template>

<script>
    import {repositoryFolderFunctions} from "./mixins/repositoryFolderFunctions";
    import {ajaxUploadMixin} from "./mixins/ajaxUploadMixin";

    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        mixins: [repositoryFolderFunctions, ajaxUploadMixin],
        provide: function() {
            return {
                mainButtons: {
                    'save_and_close': {'class': 'btn-outline-primary', 'html': this.translate('Mentés')},
                    'cancel': {'class': 'btn-outline-secondary', 'html': this.translate('Mégse')},
                }
            }
        },

        props: {
            uploadComponentProps: {default: () => {return {}}},
            editComponent: {type: String, default: null},
            editComponentProps: {default: () => {return {}}},
            detailsComponent: {type: String, default: null},
            detailsComponentProps: {default: () => {return {}}},
            searchPlaceholder: {type: String, default: ''},
            availableViewModes: {type: Array, default: () => {
                return ['list', 'folder', 'grid'];
            }},
            contextMenuComponent: {type: String, default: ''},
            buttonsComponent: {type: String, default: ''},
            sortingOptions: {type: Object, default: () => {
                return {
                    'Név': 'name'
                }
            }},
            startingPath: {type: Array, default: () => []},
            columns: {type: Object},
            shareTimeout: {default: 7},
            accessLevel: {type: Number},
            contextMenuItems: {type: Array},
            urls: {type: Object},
            defaultAccessLevel: {type: Number},
            accessLevels: {},
            user: {type: Object},
            operations: {type: Object},
            detailSearch: {type: Boolean},
            uploadComponent: {type: String},
            fileClickHandler: {type: String},
            nameField: {type: String},
            previewedTypes: {type: Object},
            playableTypes: {type: Object},
            pagination: {},
        },
        data: function () {
            return {
                monitorViewmode: true,
                tinymceConfig: {
                    toolbar: [
                        'bold italic',
                    ],
                    menubar: '',
                    content_css: '/css/app.css',
                    content_style: 'p {line-height: 1.5 !important}'
                        + '.mce-content-body {padding: .5rem}'
                },
                showDetailSearchWindow: false,
                showDetailSearchNotificationOnly: false,
                functionPopups: {
                    showSwapPopup: false,
                    showDetailsPopup: false,
                    showDescriptionPopup: false,
                    showVersionsPopup: false,
                    showSharePopup: false,
                    showRenamePopup: false,
                    showDeletePopup: false,
                    showCopyPopup: false,
                    showMovePopup: false,
                    showTagsPopup: false,
                    showLogsPopup: false,
                    showAuthorizationsPopup: false,
                    showCreateFolderPopup: false,
                    showEditorPopup: false,
                    showCommentsPopup: false,
                    showFilingPopup: false,
                    showDeleteFolderPopup: false,
                    showMoveFolderPopup: false,
                    showMediaPlayerPopup: false,
                },
                activeFunction: '',
                activeFunctionClass: '',
                showUploadPopup: false,
                showContextMenu: false,
                loading: true,
                loadingMore: false,
                viewMode: 'list',
                files: [],
                selectedFiles: [],
                viewModes: {
                    'grid': this.translate('Rácsos mappa nézet'),
                    'list': this.translate('Lista nézet'),
                    'folder': this.translate('Mappa nézet'),
                },
                selectAll: false,
                currentItem: null,
                currentItemVersions: [],
                currentItemTags: [],
                currentItemAuthorizations: [],
                users: [],
                currentCursorPosition: {x:0, y:0},
                replacementFile: null,
                currentFileversion: null,
                notificationMessage: null,
                notificationDisplayFlag: 0,
                notificationMessageClass: null,
                notificationTimeout: 3000,
                shareUrl: '',
                shareAuthRequired: 1,
                functionPopupLoading: false,
                functionPopupProcessing: false,
                copiedToClipboard: false,
                allowClipboard: true,
                originalDescription: '',
                functionPopupHeader: '',
                functionPopupSubheader: '',
                functionPopupIcon: '',
                newFilename: '',
                deleteCode: '',
                deleteCodeConfirmation: '',
                folderPickerKey: 0,
                targetFolder: null,
                currentContextMenuSubjectType: null,
                renameLabel: '',
                newComment: '',
                newAuthorizationUser: null,
                useCustomAuthorization: 0,
                operationError: '',
                detailSearchOptions: [],
                currentFilingdata: {},
                showSlideshowPopup: false,
                slideshowIndex: -1,
                uploadComponentKey: 0,
                contextMenuComponentKey: 0,
                previewSubjectFile: null,
                previewSubjectType: null,
                previewSubjectMediatype: null,
                previewSubjectUrl: null,
                showPreviewPopup: false,
            }
        },
        mounted() {
            this.sortingOption = 'name';
            if (window.localStorage) {
                let s = window.localStorage;
                let v = s.getItem('repositoryManagerViewMode');
                if ((v) && (this.availableViewModes.includes(v))) {
                    this.viewMode = v;
                }
            }

            if (this.startingPath.length == 0) {
                this.initializePath();
            } else {
                this.startingPath.forEach((p) => {
                    this.currentPath.push(p);
                });
                this.watchPathChange = true;
                this.fetchElements();
            }
            if (!navigator.clipboard) {
                this.allowClipboard = false;
            }
            window.setInterval(() => {
                this.keepCsrfAlive();
            }, 5 * 60 * 1000);
        },
        methods: {
            getIconCellClass: function(file, base) {
                if (this.previewedTypes[file.mimetype]) {
                    return base+' cursor-pointer';
                }

                return base;
            },
            getFullPathString: function(file) {
                if (!this.keyedFolders[file.folder_id]) {
                    return '';
                }
                return this.keyedFolders[file.folder_id].fullPath.join('\\')
            },
            jumpToPath: function(folder) {
                this.setCurrentPathToFolder(folder)
                this.showDetailSearchWindow = false;
                if (this.availableViewModes.includes('folder')) {
                    this.monitorViewmode = false;
                    this.viewMode = 'folder';
                }
            },
            handleElementClick: function(file, index) {
                if (this.previewedTypes[file.mimetype]) {
                    window.axios.post(this.operationsUrl, {
                        operation: 'getDownloadLink',
                        file: file.filename_on_disk,
                        version: null
                    }).then((response) => {
                        this.previewSubjectFile = file;
                        this.previewSubjectType = file.mimetype;
                        this.previewSubjectUrl = response.data;
                        this.showPreviewPopup = true;
                    });
                    return;
                }
                if (this.playableTypes[file.mimetype]) {
                    window.axios.post(this.operationsUrl, {
                        operation: 'getDownloadLink',
                        file: file.filename_on_disk,
                        version: null
                    }).then((response) => {
                        this.currentItem = file;
                        this.previewSubjectFile = file;
                        this.previewSubjectType = file.mimetype;
                        this.previewSubjectUrl = response.data;
                        this.previewSubjectMediatype = file.mimetype.split('/').shift();
                        let label = this.previewSubjectMediatype == 'audio'
                            ? this.translate('Hanganyag lejátszása')
                            : this.translate('Videoanyag lejátszása');

                        this.setFunctionPopupHeader(label, '', this.icon('play'+this.previewSubjectMediatype));
                        this.openFunctionPopup('showMediaPlayerPopup');

                    });
                    return;
                }
                if (this.fileClickHandler == '') {
                    return;
                }
                if (this[this.fileClickHandler]) {
                    this[this.fileClickHandler](file, index);
                }
            },
            showSlideshow: function(file = null, index = 0) {
                if (!this.files[index]) {
                    return;
                }
                this.slideshowIndex = index;
                this.showSlideshowPopup = true;
            },
            showPDFPreview: function(file) {

            },
            showUnauthorizedNotificationIfApplies: function(error) {
                if (error.response) {
                    if (error.response.status == 403) {

                        this.notificationMessage = error.response.data.message ?? error.response.data;
                        this.notificationDisplayFlag++;
                        this.closeFunctionPopup();
                        return true;
                    }
                }
                return false;
            },
            keepCsrfAlive: function() {
                window.axios.post(this.operationsUrl, {operation: 'keepalive'});
            },
            generateRandomCode: function(length = 5) {
                let choices = 'ACDEFGHJKLMNPQRSTUVY345679'.split('');
                let result = [];
                for (let t = 0; t < length; t++) {
                    result.push(choices[Math.floor(choices.length * Math.random())]);
                }
                return result.join('');
            },
            saveShareUrl: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'saveShareUrl',
                    authRequired: this.shareAuthRequired,
                    url: this.shareUrl,
                }).then((response) => {
                    this.shareUrl = '';
                    this.shareAuthRequired = 1;
                    this.closeFunctionPopup();
                }).catch((error) => {
                    this.showUnauthorizedNotificationIfApplies(error);
                    this.shareUrl = '';
                    this.shareAuthRequired = 1;
                    this.closeFunctionPopup();
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })
            },
            cancelShareUrl: function() {
                window.axios.post(this.operationsUrl, {operation: 'cancelShareUrl', url: this.shareUrl})
                    .then((response) => {
                        this.shareUrl = '';
                        this.shareAuthRequired = 1;
                        this.closeFunctionPopup();
                    }).catch((error) => {
                        this.shareUrl = '';
                        this.shareAuthRequired = 1;
                        this.closeFunctionPopup();
                    });
            },
            cancelDescriptionEditing: function() {
                this.currentItem.description = this.originalDescription;
                this.closeFunctionPopup('showDescriptionPopup')
            },
            saveDescription: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'updateDescription',
                    file: this.currentFilename,
                    description: this.currentItem.description
                }).then((response) => {
                    this.fetchElements();
                    this.functionPopupProcessing = false;
                    this.closeFunctionPopup('showDescriptionPopup')
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })

            },
            copyToClipboard: function(content) {
                if (!this.allowClipboard) {
                    return;
                }
                navigator.clipboard.writeText(content).then(() => {
                    this.copiedToClipboard = true;
                    window.setTimeout(() => {
                        this.copiedToClipboard = false;
                    }, 3000);
                })
            },
            handleContextMenuClick: function(event, subject, type) {
                if (this.contextMenuComponent != '') {
                    this.currentItem = subject;
                    this.showContextMenu = false;
                    this.currentContextMenuSubjectType = type;
                    if (this.currentContextMenuItems.length > 0) {
                        this.$nextTick(() => {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            this.currentCursorPosition.x = event.clientX;
                            this.currentCursorPosition.y = event.clientY;
                            this.showContextMenu = true;
                        });
                    }
                }
            },
            hideUploadPopup: function() {
                this.fetchElements();
                this.showUploadPopup = false;
            },
            fetchElements: function() {
                this.loading = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'scanRepository',
                    repository: this.repositorySlug,
                    currentPath: this.currentPath,
                    viewMode: this.viewMode,
                    searchText: this.searchText,
                    detailSearchOptions: this.detailSearchOptions,
                    sortingOption: this.sortingOption,
                    sortingDirection: this.sortingDirection,
                }).then((response) => {
                        this.files = response.data.files;
                        this.folders = response.data.folders;
                        this.allFolders = response.data.allFolders;
                        this.loading = false;
                        this.selectedFiles = [];
                    }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })
            },
            fetchMoreElements: function() {
                this.loadingMore = true;
                let cursor = this.files[this.files.length - 1] && this.files[this.files.length - 1].queryCursor
                    ? this.files[this.files.length - 1].queryCursor
                    : null
                window.axios.post(this.operationsUrl, {
                    operation: 'scanRepository',
                    repository: this.repositorySlug,
                    currentPath: this.currentPath,
                    searchText: this.searchText,
                    viewMode: this.viewMode,
                    detailSearchOptions: this.detailSearchOptions,
                    cursor: cursor,
                    sortingOption: this.sortingOption,
                    sortingDirection: this.sortingDirection,
                }).then((response) => {
                        this.files = this.files.concat(response.data.files);
                        this.loadingMore = false;
                        this.selectedFiles = [];
                    }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })
            },
            viewSelectorButtonClass: function(viewMode) {
                return this.viewMode == viewMode
                    ? this.getCSSClass('repository-manager-view-mode-button') + ' ' + this.getCSSClass('repository-manager-view-mode-button-active')
                    : this.getCSSClass('repository-manager-view-mode-button') + ' ' + this.getCSSClass('repository-manager-view-mode-button-inactive');
            },
            handleContextMenuEvent: function(payload) {
                if (this[payload.operation]) {
                    return this[payload.operation]();
                }
                //console.log(payload.operation);
            },
            downloadVersion: function(version) {
                this.currentFileversion = version;
                this.download();
            },
            download: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'getDownloadLink',
                    file: this.currentFilename,
                    version: this.currentFileversion
                }).then((response) => {
                        let a = document.createElement('a');
                        a.setAttribute('target', '_blank');
                        a.setAttribute('href', response.data);
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        this.currentFileversion = null;
                    }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A fájl nem tölthető le.'));
                    }
                });
            },
            sharelink: function() {
                this.setFunctionPopupHeader(this.translate('Dokumentum megosztása'), '', this.icon('shareDocument'));
                this.shareUrl = '';
                this.functionPopupLoading = true;
                this.copiedToClipboard = false;
                this.openFunctionPopup('showSharePopup');
                window.axios.post(this.operationsUrl, {
                    operation: 'getShareLink',
                    file: this.currentFilename,
                    authRequired: this.shareAuthRequired,
                }).then((response) => {
                        this.shareUrl = response.data;
                        this.functionPopupLoading = false;
                    }).catch((error) => {
                        if (!this.showUnauthorizedNotificationIfApplies(error)) {
                            alert(this.translate('A megosztási link nem készíthető el.'));
                        }
                    });
            },
            description: function() {
                this.functionPopupLoading = true;
                this.setFunctionPopupHeader(this.translate('Dokumentum leírása'), '', this.icon('description'));
                this.openFunctionPopup('showDescriptionPopup');
                window.axios.post(this.operationsUrl, {
                    operation: 'getDescription',
                    file: this.currentFilename,
                }).then((response) => {
                    this.currentItem.description = response.data;
                    this.originalDescription = this.currentItem.description;
                    this.functionPopupLoading = false;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate(error.response.data));
                    }
                });

            },
            handleSwap: async function() {
                if (this.replacementFile) {
                    let fileId = await this.uploadFileAsync(this.replacementFile);
                    window.axios.post(this.operationsUrl, {
                        operation: 'replaceFile',
                        replaceFile: this.currentItem.filename_on_disk,
                        newfile: fileId,
                        path: this.currentPath,
                        fileType: this.replacementFile.type
                    }).then((response) => {
                        this.fetchElements();
                        this.replacementFile = null;
                        this.closeFunctionPopup();
                    });
                }
            },
            setFunctionPopupHeader(header = '', subheader = '', icon = '') {
                this.functionPopupHeader = header;
                this.functionPopupSubheader = subheader;
                this.functionPopupIcon = icon;

            },
            swap: function() {
                this.setFunctionPopupHeader(this.translate('Dokumentum cseréje'), this.translate('A *-gal megjelölt mezők kitöltése kötelező'), this.icon('swap'));
                this.openFunctionPopup('showSwapPopup');
                //document.getElementById('swapinput').click();
            },
            versions: function() {
                this.setFunctionPopupHeader(this.translate('Verziók'), '', this.icon('versions'))
                window.axios.post(this.operationsUrl, {
                    operation: 'getVersions',
                    file: this.currentFilename
                }).then((response) => {
                    let versions = [];
                    let latest = response.data.versions[0]
                        ? response.data.versions[0].version_number + 1
                        : '-';
                    versions.push({
                        is_current: true,
                        created_at_label: this.currentItem.updated_at_label,
                        version_number: latest
                    })
                    response.data.versions.forEach((version) => {
                        version.is_current = false;
                        versions.push(version);
                    });
                    this.currentItemVersions = versions;
                    this.openFunctionPopup('showVersionsPopup');
                });
            },
            restoreVersion: function(version) {
                window.axios.post(this.operationsUrl, {
                    operation: 'restoreVersion',
                    file: this.currentFilename,
                    version: version
                }).then((response) => {
                    this.fetchElements();
                    this.closeFunctionPopup()
                    this.notificationMessage = response.data;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })
            },
            openFunctionPopup: function(name, colorClass = 'blue') {
                this.activeFunction = name.replace('show', '').replace('Popup', '').toLowerCase();
                this.activeFunctionClass = colorClass;
                Vue.set(this.functionPopups, name, true)
            },
            closeFunctionPopup: function() {
                Object.keys(this.functionPopups).forEach((k) => {
                    Vue.set(this.functionPopups, k, false);
                });
            },
            rename: function() {
                if (this.currentContextMenuSubjectType == 'file') {
                    this.setFunctionPopupHeader(this.translate('Dokumentum átnevezése'), this.translate('A *-gal megjelölt mezők kitöltése kötelező'), this.icon('rename'));
                }
                if (this.currentContextMenuSubjectType == 'folder') {
                    this.setFunctionPopupHeader(this.translate('Mappa átnevezése'), this.translate('A *-gal megjelölt mezők kitöltése kötelező'), this.icon('rename'));
                }
                this.newFilename = this.currentItem.name;
                this.openFunctionPopup('showRenamePopup');
            },
            handleRename: function() {
                if (this.currentItem.name == this.newFilename) {
                    this.closeFunctionPopup();
                    return;
                }
                let operation = 'renameFile';
                let subject = this.currentFilename
                if (this.currentContextMenuSubjectType == 'folder') {
                    operation = 'renameFolder';
                    subject = this.currentItem.id;
                }
                window.axios.post(this.operationsUrl, {
                    operation: operation,
                    file: subject,
                    newname: this.newFilename,
                }).then((response) => {
                    this.fetchElements();
                    this.closeFunctionPopup()
                    this.notificationMessage = response.data;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })

            },
            delete: function() {
                this.setFunctionPopupHeader(this.translate('Dokumentum törlése'), this.translate('A *-gal megjelölt mezők kitöltése kötelező'), this.icon('delete'));
                this.deleteCodeConfirmation = '';
                this.deleteCode = this.generateRandomCode();
                this.openFunctionPopup('showDeletePopup', 'red');
            },
            handleDeletion: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'deleteFile',
                    file: this.currentFilename,
                }).then((response) => {
                    this.fetchElements();
                    this.closeFunctionPopup()
                    this.functionPopupProcessing = false;
                    this.notificationMessage = response.data;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    this.functionPopupProcessing = false;
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })
            },
            deleteFolder: function() {
                this.setFunctionPopupHeader(this.translate('Mappa törlése'), this.translate('A mappa és az összes benne lévő mappa és fájl törlésre kerül'), this.icon('delete'));
                this.deleteCodeConfirmation = '';
                this.deleteCode = this.generateRandomCode();
                this.openFunctionPopup('showDeleteFolderPopup', 'red');
            },
            handleFolderDeletion: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'deleteFolder',
                    folder: this.currentItem.id,
                }).then((response) => {
                    this.fetchElements();
                    this.closeFunctionPopup()
                    this.functionPopupProcessing = false;
                    if (response.data.failed.length == 0) {
                        this.notificationMessage = response.data.message;
                        this.notificationDisplayFlag++;
                    } else {
                        this.notificationMessage = response.data.message
                            +'<br><br>'
                            +response.data.failed.map((f) => {return f.name}).join('<br>');
                        this.notificationTimeout = 0;
                        this.notificationDisplayFlag++;
                    }
                }).catch((error) => {
                    this.functionPopupProcessing = false;
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(this.translate('A művelet nem sikerült'));
                    }
                })
            },
            copy: function() {
                this.folderPickerKey++;
                this.newFilename = this.translate('Másolat')+' - '+this.currentItem.name;
                this.setFunctionPopupHeader(this.translate('Másolat készítése'), '', this.icon('copy'));
                this.openFunctionPopup('showCopyPopup');
            },
            handleCopy: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'copyFile',
                    file: this.currentFilename,
                    targetFolder: this.targetFolder,
                    newName: this.newFilename,
                }).then((response) => {
                    this.currentPath = response.data.folder.path;
                    this.closeFunctionPopup()
                    this.notificationMessage = response.data.message;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })

            },
            move: function() {
                this.folderPickerKey++;
                this.setFunctionPopupHeader(this.translate('Dokumentum áthelyezése'), '', this.icon('move'));
                this.openFunctionPopup('showMovePopup');
            },
            handleMove: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'moveFile',
                    file: this.currentFilename,
                    targetFolder: this.targetFolder,
                }).then((response) => {
                    this.currentPath = response.data.folder.path;
                    this.closeFunctionPopup()
                    this.notificationMessage = response.data.message;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })


            },
            moveFolder: function() {
                this.folderPickerKey++;
                this.setFunctionPopupHeader(this.translate('Mappa áthelyezése'), '', this.icon('move'));
                this.openFunctionPopup('showMoveFolderPopup');
            },
            handleFolderMove: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'moveFolder',
                    folder: this.currentItem.id,
                    targetFolder: this.targetFolder,
                }).then((response) => {
                    this.currentPath = response.data.folder.path;
                    this.closeFunctionPopup()
                    this.notificationMessage = response.data.message;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })


            },
            edit: function() {
                this.setFunctionPopupHeader(this.translate('Szerkesztés'), this.translate('A *-gal megjelölt mezők kitöltése kötelező'), this.icon('edit'));
                this.openFunctionPopup('showEditorPopup');
            },
            handleEdit: function() {
                this.notificationMessage = this.translate('Módosítások elmentve');
                this.notificationDisplayFlag++;
                this.closeFunctionPopup()
                this.fetchElements();
            },
            details: function() {
                this.setFunctionPopupHeader(this.translate('Részletek'), '', this.icon('details'));
                this.openFunctionPopup('showDetailsPopup');
            },
            closeDetails: function() {
                this.closeFunctionPopup()
                this.fetchElements();
            },
            tags: function() {
                this.setFunctionPopupHeader(this.translate('Címkék'), '', this.icon('tags'));
                this.currentItemTags = [];
                this.currentItem.tags.forEach((t) => {
                    this.currentItemTags.push(t.id);
                })
                this.openFunctionPopup('showTagsPopup');
            },
            saveTags: function() {
                let operation = Array.isArray(this.currentFilename) ? 'saveTagsMultiple' : 'saveTags'
                window.axios.post(this.operationsUrl, {
                    operation: operation,
                    file: this.currentFilename,
                    tags: this.currentItemTags,
                }).then((response) => {
                    this.fetchElements();
                    this.closeFunctionPopup()
                }).catch((error) => {
                    if (error.response) {
                        this.notificationMessage = error.response.data;
                        this.notificationDisplayFlag++;
                    }
                })
            },
            cancelTagEditing: function() {
                this.closeFunctionPopup();
            },
            loadComments: function(callback) {
                window.axios.post(this.operationsUrl, {
                    operation: 'loadComments',
                    file: this.currentFilename,
                }).then((response) => {
                    callback(response);
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })


            },
            comments: function() {
                this.setFunctionPopupHeader(this.translate('Megjegyzések'), '', this.icon('comment'));
                this.functionPopupLoading = true;
                this.newComment = '';
                this.openFunctionPopup('showCommentsPopup');
                this.loadComments((response) => {
                    this.currentItem.comments = response.data.comments;
                    this.functionPopupLoading = false;
                })
            },
            addComment: function() {
                window.axios.post(this.operationsUrl, {
                    operation: 'addComment',
                    file: this.currentFilename,
                    comment: this.newComment,
                }).then((response) => {
                    this.loadComments((response2) => {
                        this.currentItem.comments = response2.data.comments;
                        this.currentItem.comments_count = response2.data.comments.length;
                        this.functionPopupProcessing = false;
                        this.newComment = '';
                    });
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })
            },
            closeCommentsEditing: function() {
                this.closeFunctionPopup();
            },
            logs: function() {
                this.setFunctionPopupHeader(this.translate('Naplózás'), '', this.icon('logs'));
                this.functionPopupLoading = true;
                this.openFunctionPopup('showLogsPopup');
                window.axios.post(this.operationsUrl, {
                    operation: 'loadLogs',
                    file: this.currentFilename,
                }).then((response) => {
                    this.currentItem.logs = response.data.logs;
                    this.functionPopupLoading = false;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })
            },
            authorizations: function() {
                this.setFunctionPopupHeader(this.translate('Jogosultságok'), '', this.icon('authorizations'));
                this.functionPopupLoading = true;
                this.openFunctionPopup('showAuthorizationsPopup');
                window.axios.post(this.operationsUrl, {
                    operation: 'loadAuthorizations',
                    file: this.currentFilename,
                }).then((response) => {
                    this.users = response.data.users;
                    let authorizations = response.data.authorizations.map((a) => {
                        a.name = this.usersKeyed[a.user_id];
                        return a;
                    });
                    authorizations.sort((a, b) => {
                        if (a.name == b.name) {
                            return 0;
                        }
                        return a.name < b.name ? -1 : 1;
                    })
                    this.currentItemAuthorizations = authorizations;
                    this.useCustomAuthorization = this.currentItemAuthorizations.length == 0 ? 0 : 1;
                    this.newAuthorizationUser = null;
                    this.functionPopupLoading = false;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })
            },
            saveAuthorizations: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'saveAuthorizations',
                    file: this.currentFilename,
                    authorizations: this.currentItemAuthorizations,
                }).then((response) => {
                    this.functionPopupProcessing = false;
                    this.closeFunctionPopup();
                    this.currentItemAuthorizations = [];
                    this.newAuthorizationUser = null;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        alert(error.response.data);
                    }
                })

            },
            cancelAuthorizations: function() {
                this.closeFunctionPopup();
            },
            removeAuthorizedUser: function(index) {
                this.currentItemAuthorizations.splice(index, 1);
            },
            addUserToAuthorizationList: function() {
                let authorizations = this.currentItemAuthorizations;
                let newItem = {
                    'file_id': this.currentItem.id,
                    'user_id': this.newAuthorizationUser,
                    'accesslevel': this.defaultAccessLevel
                }
                authorizations.push(newItem);
                authorizations.sort((a, b) => {
                    if (a.name == b.name) {
                        return 0;
                    }
                    return a.name < b.name ? -1 : 1;
                });
                this.useCustomAuthorization = 1;
                this.currentItemAuthorizations = authorizations;
            },
            createFolder: function() {
                this.setFunctionPopupHeader(this.translate('Új mappa létrehozása'), '', this.icon('createFolder'));
                this.newFilename = '';
                this.functionPopupLoading = false;
                this.currentItem = {id: this.repository.id};
                this.openFunctionPopup('showCreateFolderPopup')
            },
            handleCreateFolder: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'createFolder',
                    name: this.newFilename,
                    currentPath: this.currentPath,
                }).then((response) => {
                    this.functionPopupProcessing = false;
                    this.notificationMessage = response.data;
                    this.notificationDisplayFlag++;
                    this.closeFunctionPopup();
                    this.fetchElements();
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        this.operationError = error.response.data;
                        this.functionPopupProcessing = false;
                    }
                })

            },
            upload: function() {
                this.uploadComponentKey++;
                this.showUploadPopup = true;
            },
            tagSelected: function() {
                if (this.selectedFiles.length == 0) {
                    this.notificationMessage = this.translate('Válasszon ki legalább egy elemet');
                    this.notificationDisplayFlag++;
                    return;
                }
                this.currentItem = {
                    id: this.selectedFiles,
                    name: this.selectedFiles.length.toString()+' '+this.translate('fájl'),
                    filename_on_disk: this.selectedFiles
                }
                this.setFunctionPopupHeader(this.translate('Csoportos címkézés'), '', this.icon('tags'));
                this.currentItemTags = [];
                this.openFunctionPopup('showTagsPopup');
            },
            downloadSelected: function() {
                if (this.selectedFiles.length == 0) {
                    this.notificationMessage = this.translate('Válasszon ki legalább egy elemet');
                    this.notificationDisplayFlag++;
                    return;
                }
                window.axios.post(this.operationsUrl, {
                    operation: 'downloadSelected',
                    files: this.selectedFiles
                }).then((response) => {
                    this.notificationMessage = response.data;
                    this.notificationTimeout = 15000;
                    this.notificationDisplayFlag++;
                }).catch((error) => {
                    if (!this.showUnauthorizedNotificationIfApplies(error)) {
                        this.notificationMessage = error.response.data;
                        this.notificationDisplayFlag++;
                    }
                });
            },
            toggleSorting: function(field) {
                if (this.sortingOption == field) {
                    this.sortingDirection = this.sortingDirection == 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortingOption = field;
                    this.sortingDirection = 'asc';
                }
                if (this.viewMode == 'list') {
                    this.fetchElements();
                }
            },
            sortingArrow: function(field) {
                if (this.sortingOption != field) {
                    return this.icon('sorting');
                }
                return this.sortingDirectionValue == 1
                    ? this.icon('sorting-asc')
                    : this.icon('sorting-desc');
            },
            sortingArrowClass: function(field) {
                if (this.sortingOption == field) {
                    return this.getCSSClass('repository-manager-sorting-arrow') + ' ' + this.getCSSClass('repository-manager-sorting-arrow-active');
                }
                return this.getCSSClass('repository-manager-sorting-arrow') + ' ' + this.getCSSClass('repository-manager-sorting-arrow-inactive');
            },
            showDetailSearch: function() {
                this.currentItem = {id: -1};
                this.fetchDetailSearchOptions(() => {
                    this.showDetailSearchWindow = true;
                }, true)
            },
            fetchDetailSearchOptions: function(callback, useExistingValues) {
                window.axios.post(this.operationsUrl, {
                    operation: 'fetchDetailSearchOptions',
                }).then((response) => {
                    let newOptions = response.data.options;
                    if (useExistingValues) {
                        this.detailSearchOptions.forEach((o) => {
                            let existing = newOptions.findIndex((e) => {
                                return e.field == o.field;
                            });
                            if (existing > -1) {
                                newOptions[existing].value = o.value;
                            }
                        })
                    }
                    this.detailSearchOptions = newOptions;
                    callback();
                }).catch((error) => {
                    if (error.response.data) {
                        alert(error.response.data);
                    }
                    console.log(error);
                });
            },
            applyDetailSearch: function() {
                this.currentItem = null;
                if (this.viewMode == 'list') {
                    this.fetchElements();
                } else {
                    this.viewMode = 'list';
                }
            },
            resetDetailSearch: function() {
                this.functionPopupLoading = true;
                this.showDetailSearchWindow = false;
                this.fetchDetailSearchOptions(() => {
                }, false)
            },
            clearDetailSearch: function() {
                this.fetchDetailSearchOptions(() => {
                    this.showDetailSearchWindow = false;
                    this.fetchElements();
                }, false);
            },
            handleUploadError: function(payload) {
                if (!this.showUnauthorizedNotificationIfApplies(payload)) {
                    if ((payload.response) && (payload.response.data)) {
                        if (payload.response.data.message) {
                            alert(payload.response.data.message);
                        } else {
                            alert(payload.response.data);
                        }
                    } else {
                        console.log(payload);
                    }
                }
            },
            filing: function() {
                this.setFunctionPopupHeader(this.translate('Iktatás'), '', this.icon('filing'));
                this.openFunctionPopup('showFilingPopup');
            },
            handleFiling: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'updateFiling',
                    filingdata: this.currentFilingdata,
                    file: this.currentFilename,
                }).then((response) => {
                    this.fetchElements();
                    this.functionPopupProcessing = false;
                    this.closeFunctionPopup()
                }).catch((error) => {
                    if (error.response) {
                        this.notificationMessage = error.response.data;
                        this.notificationDisplayFlag++;
                    }
                })
            },
            toggleDetailSearch: function() {
                if (this.showDetailSearchWindow) {
                    return this.clearDetailSearch();
                } else {
                    return this.showDetailSearch();
                }

            },
            clearFiling: function() {
                this.functionPopupProcessing = true;
                window.axios.post(this.operationsUrl, {
                    operation: 'clearFiling',
                    file: this.currentFilename,
                }).then((response) => {
                    this.fetchElements();
                    this.functionPopupProcessing = false;
                    this.closeFunctionPopup()
                }).catch((error) => {
                    if (error.response) {
                        this.notificationMessage = error.response.data;
                        this.notificationDisplayFlag++;
                    }
                })
            },
            folderViewFileRowClass: function(fileId) {
                let base = [
                    this.getCSSClass('repository-manager-folderview-item'),
                    this.getCSSClass('repository-manager-folderview-item-file')
                ];
                if (this.selectedFiles.indexOf(fileId) > -1) {
                    base.push(this.getCSSClass('repository-manager-folderview-item-file-selected'));
                }

                return base.join(' ');
            }
        },
        computed: {
            keyedFolders: function() {
                if (!this.allFolders) {
                    return {}
                }
                let result = {}
                result[this.repository.fid] = {
                    folder_id: null,
                    name: this.repository.name,
                    path: [
                        {folder_id: null, id: this.repository.fid, name: this.repository.name}
                    ],
                    fullPath: [this.repository.name]
                }
                this.allFolders.forEach((f) => {
                    result[f.id] = {...f};
                    result[f.id].fullPath = f.path.map(fp => fp.name);
                });
                return result;
            },
            uploadComponentPropsComputed: function() {
                let result = {};
                Object.keys(this.uploadComponentProps).forEach((key) => {
                    result[key] = {...this.uploadComponentProps[key]}
                })
                return result;
            },
            detailSearchLabel: function() {
                if (this.showDetailSearchWindow) {
                    return this.translate('Gyorskeresés')
                } else {
                    return this.translate('Részletes keresés')
                }
            },
            showFunctionPopup: function() {
                this.contextMenuComponentKey++;
                return Object.keys(this.functionPopups).filter((k) => {
                    return this.functionPopups[k] === true;
                }).length > 0;
            },
            currentFilename: function() {
                if (this.currentItem) {
                    return this.currentItem.filename_on_disk;
                }
                return '';
            },
            currentAccessLevel: function() {
                if (this.currentItem) {
                    if ((this.currentItem.accesslevel) && (this.currentItem.accesslevel !== null)) {
                        return this.currentItem.accesslevel;
                    }
                }
                return this.accessLevel;
            },
            repositoryAccessLevel: function() {
                return this.accessLevel;
            },
            currentContextMenuItems: function() {
                if (this.contextMenuItems[this.currentAccessLevel]) {
                    if (this.contextMenuItems[this.currentAccessLevel][this.currentContextMenuSubjectType]) {
                        return this.contextMenuItems[this.currentAccessLevel][this.currentContextMenuSubjectType].filter((a) => {
                            return !a['repositoryAccessLevel'] || a['repositoryAccessLevel'] <= this.repositoryAccessLevel;
                        });
                    }
                }
                return [];
            },
            usersKeyed: function() {
                let result = {};
                this.users.forEach((user) => {
                    result[user.id] = user;
                });
                return result;
            },
            currentItemAuthorizationRemainingUsers: function() {
                if (!this.currentItemAuthorizations) {
                    return this.users;
                }
                let existing = this.currentItemAuthorizations.map((c) => {
                    return c.user_id;
                })
                return this.users.filter((u) => {
                    return !existing.includes(u.id) && u.id != this.user.id;
                });
            },
            accessLevelsWithoutNoAccess: function() {
                return {
                    1: this.accessLevels[1],
                    2: this.accessLevels[2],
                }
            },
            currentOperations: function() {
                if (!this.operations[this.viewMode]) {
                    return [];
                }
                return this.operations[this.viewMode];
            },
            currentViewColumns: function() {
                if (this.columns[this.viewMode]) {
                    return this.columns[this.viewMode];
                }
                return [];
            },
            availableViewModesFiltered: function() {
                if (this.showDetailSearchWindow) {
                    return [];
                }

                return this.availableViewModes;
            }
        },
        watch: {
            viewMode: function(newValue, oldValue) {
                if (!this.monitorViewmode) {
                    this.monitorViewmode = true;
                    return;
                }
                if ((newValue == 'list') || (oldValue == 'list')) {
                    this.currentPath = [];
                    this.initializePath()
                }
                if (window.localStorage) {
                    let s = window.localStorage;
                    s.setItem('repositoryManagerViewMode', newValue);
                }

            },
            showDetailSearchWindow: function(value) {
                if (value) {
                    if (this.searchText !== '') {
                        let fulltextSearchOption = this.detailSearchOptions.find(o => o['fulltext']);
                        if (fulltextSearchOption) {
                            fulltextSearchOption.value = this.searchText;
                            this.searchText = '';
                        }
                    }
                } else {
                }
            },
            selectAll: function(value) {
                if (value) {
                    this.selectedFiles = this.files.map((f) => f.id);
                } else {
                    this.selectedFiles = [];
                }
            },
        }

    }
</script>
